import { Component, Input, OnChanges, OnInit, Output, ViewChild, EventEmitter, AfterViewInit, AfterContentInit, ChangeDetectorRef } from '@angular/core';
import { PlotlyService } from './services/plotly-service';
import { Subscription } from 'rxjs';
import { GraphicActionInterface } from '../../../../../utils/models/common.interface'
import { GraphicActionsComponent } from '../graphic-actions/graphic-actions.component';

@Component({
  selector: 'graphic-plotly',
  templateUrl: './graphic-plotly.component.html',
  styleUrls: ['./graphic-plotly.component.scss']
})
export class GraphicPlotlyComponent implements OnInit, OnChanges, AfterViewInit, AfterContentInit {
  @ViewChild('chartGenericPlot', { static: true }) chartGenericPlot: any;
  @ViewChild('GraphicActionsChild') actionChild: GraphicActionsComponent;

  @Input() layoutGrafic: any = {};
  @Input() dataGrafic = [];
  @Input() configGrafic = [];
  @Input() idChart = 'chartGenericPlot'
  @Input() actions: GraphicActionInterface;

  @Output() getClickPoint: EventEmitter<any> = new EventEmitter();
  @Output() getEventHoverPoint: EventEmitter<any> = new EventEmitter();
  @Output() getEventUnHoverPoint: EventEmitter<any> = new EventEmitter();

  plotlyGrafic
  sub: Subscription;
  subSelect: Subscription;
  useCrossHair = false
  xaxis = {}
  yaxis = {}


  constructor(
    private readonly plotService: PlotlyService,
    private readonly cdref: ChangeDetectorRef
  ) { }
  ngAfterContentInit(): void {
    this.cdref.detectChanges()
  }

  ngAfterViewInit(): void {
    this.actionChild?.disableAction('zoomOut', true)
  }

  ngOnInit(): void {
    this.sub = this.plotService.exportEvent.subscribe((e) => {
      if (e) {
        this.updateGrafic(e)
      }
    })
    this.subSelect = this.plotService.selectEvent.subscribe((e) => {
      if (e) {
        this.selectEvent(e)
      }
    })
  }

  ngOnChanges() {
    this.initGrafic();
    this.plotlyGrafic = this.plotService.getPlotly();

    this.chartGenericPlot.nativeElement.on('plotly_click', (data: any) => {
      this.getClickPoint.emit(data);
    });

    this.chartGenericPlot.nativeElement.on('plotly_hover', (data: any) => {
      this.getEventHoverPoint.emit(data);
    });

    this.chartGenericPlot.nativeElement.on('plotly_unhover', (data: any) => {
      this.getEventUnHoverPoint.emit(data);
    });


    const modeBarGroup = document.querySelectorAll('.modebar-group')

    modeBarGroup.forEach((item,index) => {
      const botoesModebar = item.querySelectorAll('.modebar-btn')
      botoesModebar[0]?.setAttribute('data-title', 'Aumentar zoom')
      botoesModebar[1]?.setAttribute('data-title', 'Diminuir zoom')
      botoesModebar[2]?.setAttribute('data-title', 'Voltar para visualização padrão')
    })
  }

  initGrafic() {
    if (this.configGrafic) {
      this.plotService.plotGrafic(this.chartGenericPlot.nativeElement, this.dataGrafic, this.layoutGrafic, this.configGrafic);
    } else {
      this.plotService.plotGrafic(this.chartGenericPlot.nativeElement, this.dataGrafic, this.layoutGrafic);
    }
    this.xaxis = {...this.chartGenericPlot.nativeElement.layout?.xaxis?.range}
    this.yaxis = {...this.chartGenericPlot.nativeElement.layout?.yaxis?.range}
  }

  updateGrafic(e) {
    const newLayout = {
      'mapbox.style': e
    };
    this.plotlyGrafic.update(this.chartGenericPlot.nativeElement, {}, newLayout, this.configGrafic);
  }

  selectEvent(selectedPoints) {
    const updatedData = this.dataGrafic
    updatedData[0].lon = selectedPoints.map(data => data.lon)
    updatedData[0].lat = selectedPoints.map(data => data.lat)
    updatedData[0].z = selectedPoints.map(data => data.value)
    updatedData[0].customdata = selectedPoints.map(data => data.id)

    updatedData[1].lon = selectedPoints.map(data => data.lon)
    updatedData[1].lat = selectedPoints.map(data => data.lat)

    this.plotlyGrafic.update(this.chartGenericPlot.nativeElement, updatedData, this.layoutGrafic, this.configGrafic);
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.subSelect?.unsubscribe();
  }

  graphicActions(event) {
    this.useCrossHair = false;
    const chartElement = this.chartGenericPlot.nativeElement;

    const clickZoomButton = (attr, val) => {
      chartElement.querySelector(`a[data-attr="${attr}"][data-val="${val}"]`).click();
    };

    const disableZoomOut = (disable) => {
      this.actionChild?.disableAction('zoomOut', disable);
    };

    switch (event) {
      case 'zoomIn':
        this.layoutGrafic.dragmode = 'pan';
        clickZoomButton('zoom', 'in');
        disableZoomOut(false);
        this.plotlyGrafic.update(chartElement, this.dataGrafic, this.layoutGrafic, this.configGrafic);
        break;
      case 'zoomOut':
        const { yaxis } = chartElement.layout;
        const zoomYAxis = [...yaxis.range];
        if (parseInt(zoomYAxis[0]) <= parseInt(this.yaxis[0])) {
          this.layoutGrafic.dragmode = false;
            clickZoomButton('zoom', 'reset');
            disableZoomOut(true);
        } else {
          this.layoutGrafic.dragmode = 'pan';
            clickZoomButton('zoom', 'out');
        }
        this.plotlyGrafic.update(chartElement, this.dataGrafic, this.layoutGrafic, this.configGrafic);
        break;
      case 'refresh':
        this.layoutGrafic.dragmode = false;
        clickZoomButton('zoom', 'reset');
        disableZoomOut(true);
        this.plotlyGrafic.update(chartElement, this.dataGrafic, this.layoutGrafic, this.configGrafic);
        break;
      default:
        this.useCrossHair = true;
        this.layoutGrafic.dragmode = 'zoom';
        this.plotlyGrafic.update(chartElement, this.dataGrafic, this.layoutGrafic, this.configGrafic);
        this.relayoutDragmode();
      break;
    }
}

  relayoutDragmode() {
    const chartElement = this.chartGenericPlot.nativeElement;
    const handleRelayout = () => {
        this.useCrossHair = false;
        this.layoutGrafic.dragmode = false;
        this.plotlyGrafic.update(chartElement, this.dataGrafic, this.layoutGrafic, this.configGrafic);
        this.actionChild?.disableAction('zoomOut', false);
        chartElement.removeAllListeners('plotly_relayout');
    };

    chartElement.on('plotly_relayout', handleRelayout);
  }
}
